import { IOffer } from '../../../../types/offer';
import { getAgentFee } from './getAgentFee';
import { getClientFee } from './getClientFee';

export function getFeePrice(offer: IOffer, isAgent: boolean) {
  return isAgent ? getAgentFee(offer) : getClientFee(offer);
}
